import CircularProgress from 'react-native-circular-progress-indicator';
import React, { useState, useEffect } from 'react';
import { View, ScrollView, StyleSheet, SafeAreaView, Text } from 'react-native';
import { Card } from '@rneui/themed';
import { useRoute } from '@react-navigation/native';
import { useAuth } from '../config/AuthContext';
import config from '../config/config';

export function OeeScreen() {
  const route = useRoute();
  const { deviceName } = route.params;
  // const azureUrl = 'http://localhost:3001/api';
  const tableName = 'equipstates';
  const { maquinaId } = useAuth();
  const [oee, setOee] = useState(['']);
  const [oeeDisp, setOeeDisp] = useState(['']);
  const [oeePerf, setOeePerf] = useState(['']);
  const [oeeQual, setOeeQual] = useState(['']);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  async function fetchData() {
    try {
      const tabelaEndpoint = `${config.apiBaseUrl}/tables/${tableName}?$filter=maquinaId eq '${maquinaId}'`;
      const response = await fetch(tabelaEndpoint, {
        headers: {
          'ZUMO-API-VERSION': '2.0.0',
        },
      });
      const data = await response.json();
      const parsedData = JSON.parse(data[0].dados);

      //Filtra e armazena os dados do Oee Principal
      const oee = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.Oee * 100);
      setOee(oee);

      const oeeDisp = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.OeeDisp * 100);
      setOeeDisp(oeeDisp);

      const oeePerf = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.OeePerf * 100);
      setOeePerf(oeePerf);

      const oeeQual = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.OeeQual * 100);
      setOeeQual(oeeQual);
    } catch (error) {
      console.log(`Erro ao listar dados: ${error.message}`);
    }
  }

  const getCircleColor = (value) => {
    if (value >= 0 && value <= 40) {
      return '#E20000'; // Red
    } else if (value > 40 && value <= 70) {
      return '#FFD329'; // Orange
    } else if (value > 70 && value <= 100) {
      return '#198A07'; // Green
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView contentContainerStyle={styles.scrollContainer}>
        <Card containerStyle={styles.cardContainer}>
          <Card.Title style={{ fontSize: 22, color: '#0081CF' }}>
            OEE
          </Card.Title>
          <Card.Divider />
          <View style={{ alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress
              radius={100}
              value={oee[0]}
              progressValueColor="transparent" // escondemos o valor padrão
              activeStrokeColor={getCircleColor(oee)}
              inActiveStrokeColor={getCircleColor(oee)}
              inActiveStrokeOpacity={0.2}
              strokeLinecap="round"
            />
            <View style={{ position: 'absolute', alignItems: 'center' }}>
              <Text
                style={{ fontSize: 48, color: '#040404', fontWeight: 'bold' }}
              >
                {Number(oee[0]).toFixed(1)}%
              </Text>
            </View>
          </View>
        </Card>

        <View style={styles.cardRow}>
          <Card containerStyle={styles.smallCardContainer}>
            <Card.Title style={styles.smallCardTitle}>
              Disponibilidade
            </Card.Title>
            <Card.Divider />
            <View style={{ alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress
                radius={60}
                value={oeeDisp[0]}
                progressValueColor={'transparent'}
                inActiveStrokeColor={getCircleColor(oeeDisp)}
                activeStrokeColor={getCircleColor(oeeDisp)}
                inActiveStrokeOpacity={0.2}
                strokeLinecap="round"
              />
              <View style={{ position: 'absolute', alignItems: 'center' }}>
                <Text
                  style={{ fontSize: 24, color: '#040404', fontWeight: 'bold' }}
                >
                  {Number(oeeDisp[0]).toFixed(1)}%
                </Text>
              </View>
            </View>
          </Card>

          <Card containerStyle={styles.smallCardContainer}>
            <Card.Title style={styles.smallCardTitle}>Performance</Card.Title>
            <Card.Divider />
            <View style={{ alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress
                radius={60}
                value={oeePerf[0]}
                progressValueColor={'transparent'}
                inActiveStrokeColor={getCircleColor(oeePerf)}
                activeStrokeColor={getCircleColor(oeePerf)}
                inActiveStrokeOpacity={0.2}
                strokeLinecap="round"
              />
              <View style={{ position: 'absolute', alignItems: 'center' }}>
                <Text
                  style={{ fontSize: 24, color: '#040404', fontWeight: 'bold' }}
                >
                  {Number(oeePerf[0]).toFixed(1)}%
                </Text>
              </View>
            </View>
          </Card>

          <Card containerStyle={styles.smallCardContainer}>
            <Card.Title style={styles.smallCardTitle}>Qualidade</Card.Title>
            <Card.Divider />
            <View style={{ alignItems: 'center', justifyContent: 'center' }}>
              <CircularProgress
                radius={60}
                value={oeeQual[0]}
                progressValueColor={'transparent'}
                inActiveStrokeColor={getCircleColor(oeeQual)}
                activeStrokeColor={getCircleColor(oeeQual)}
                inActiveStrokeOpacity={0.2}
                strokeLinecap="round"
              />
              <View style={{ position: 'absolute', alignItems: 'center' }}>
                <Text
                  style={{ fontSize: 24, color: '#040404', fontWeight: 'bold' }}
                >
                  {Number(oeeQual[0]).toFixed(1)}%
                </Text>
              </View>
            </View>
          </Card>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#CCCCCA',
  },
  scrollContainer: {
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 20,
  },
  cardContainer: {
    backgroundColor: '#F3F3F1',
    marginTop: 10,
    width: 290,
    height: 330,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 5,
  },
  cardRow: {
    flexDirection: 'row', // cards em linha e com margem igual entre eles
    justifyContent: 'space-between',
    marginTop: 50,
  },
  smallCardContainer: {
    backgroundColor: '#F3F3F1',
    width: 200, // Largura dos cards pequenos dividida em 3 colunas com margens
    height: 250,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 5,
    elevation: 5,
  },
  smallCardTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#0081CF',
  },
});
